export default "__VITE_ASSET__CtRozerB__"